import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable, of} from 'rxjs';
import {switchMap, take, tap} from 'rxjs/operators';
import {AuthService} from './auth.service';

/**
 * Guard obsługujący proces autoryzacji dla widoku
 * Szczegółów Rezerwacji (Vet Reservation Details).
 * Wdraża uniwersalny mechanizm przechwytywania żądanego adresu URL (returnUrl)
 * w celu zapewnienia płynnego odtworzenia kontekstu nawigacji (Deep Linking)
 * po pomyślnym uwierzytelnieniu użytkownika.
 */
@Injectable({
  providedIn: 'root'
})
export class VrdAuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
  ) {
  }

  /**
   * Weryfikuje stan uwierzytelnienia przed aktywacją widoku szczegółów rezerwacji.
   * W przypadku wykrycia braku sesji, przechwytuje pełną ścieżkę docelową (state.url)
   * i przekazuje ją do mechanizmu logowania automatycznego lub kieruje użytkownika
   * do widoku logowania z parametrem returnUrl.
   *
   * @param route Migawka aktywowanej ścieżki.
   * @param state Migawka stanu routera, zawierająca pełny docelowy adres URL.
   * @returns Observable emitujący wartość logiczną lub bezpieczne drzewo routingu (UrlTree).
   */
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.authService.userIsAuthenticated.pipe(
      take(1),
      switchMap(isAuthenticated => {
        if (!isAuthenticated) {
          return this.authService.autoLoginWithReturnUrl({queryParams: {returnUrl: state.url}});
        } else {
          // authenticated check token
            return of(isAuthenticated);
        }
      }),
      tap(isAuthenticated => {
        if (!isAuthenticated) {
          this.router.navigate(['signin'], {queryParams: {returnUrl: state.url}});
        }
      })
    );
  }

}
